import React from "react";

const Instagram = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true" 
      focusable="false"
    >
      <path
        d="M18.3301 6.30914C18.3186 4.51283 17.5177 3.14979 15.968 2.24246C15.2861 1.84301 14.5324 1.67019 13.7421 1.66978C11.2471 1.66774 8.75215 1.66163 6.2572 1.67141C4.22651 1.67915 2.53006 2.91868 1.88767 4.8544C1.79311 5.13972 1.75846 5.44543 1.6965 5.74176C1.6855 5.79434 1.67653 5.84733 1.66675 5.89991V14.1017C1.71158 14.3512 1.73604 14.6064 1.80411 14.8493C2.32095 16.6941 3.51972 17.8273 5.38859 18.2495C5.55612 18.2874 5.72854 18.3054 5.89851 18.3327H14.102C14.3518 18.2878 14.607 18.2634 14.8503 18.1953C16.6931 17.6793 17.8295 16.4826 18.2453 14.6157C18.3121 14.317 18.3292 14.0023 18.3301 13.695C18.3366 11.233 18.3456 8.77108 18.3301 6.30914ZM10.0076 14.568C7.49836 14.5823 5.43098 12.5182 5.43221 10C5.43343 7.48427 7.46697 5.44787 9.9929 5.43361C12.5021 5.41934 14.5695 7.48305 14.5683 10.0012C14.567 12.517 12.5335 14.5534 10.0076 14.568ZM14.8438 6.54596C14.0897 6.54352 13.4555 5.90847 13.4559 5.15603C13.4559 4.40114 14.0881 3.7718 14.8458 3.77261C15.6077 3.77302 16.2317 4.39788 16.2297 5.15847C16.228 5.91662 15.5971 6.54841 14.8438 6.54596Z"
        fill="white"
      />
      <path
        d="M1.66675 14.1035C1.71158 14.353 1.73604 14.6081 1.80411 14.8511C2.32095 16.6959 3.51972 17.829 5.38859 18.2513C5.55612 18.2892 5.72853 18.3071 5.89851 18.3345C4.48778 18.3345 3.07706 18.3345 1.66675 18.3345C1.66675 16.9241 1.66675 15.5138 1.66675 14.1035Z"
        fill="white"
      />
      <path
        d="M13.5839 10.0086C13.5773 11.9904 11.96 13.5968 9.9847 13.5838C8.00618 13.5707 6.41 11.9647 6.41652 9.99316C6.42305 8.01179 8.04083 6.4046 10.0161 6.41805C11.9946 6.4311 13.5904 8.03706 13.5839 10.0086Z"
        fill="white"
      />
      <path
        d="M15.2448 5.15567C15.2456 5.37496 15.0601 5.56164 14.8433 5.56042C14.6285 5.5592 14.4389 5.36599 14.4422 5.15159C14.4458 4.94086 14.6268 4.7607 14.8388 4.75785C15.0609 4.75499 15.2439 4.93434 15.2448 5.15567Z"
        fill="white"
      />
    </svg>
  );
};

export default Instagram;
